export default __webpack_public_path__ + "static/media/acd.3e760fbc.png";